import { render, staticRenderFns } from "./versionManageAddModule.vue?vue&type=template&id=1cf88e70&scoped=true&"
import script from "./versionManageAddModule.vue?vue&type=script&lang=js&"
export * from "./versionManageAddModule.vue?vue&type=script&lang=js&"
import style0 from "./versionManageAddModule.vue?vue&type=style&index=0&id=1cf88e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf88e70",
  null
  
)

export default component.exports